var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PrivateTopicManage"},[_c('easyCruds',{ref:"mainTable",attrs:{"data":_vm.data,"tableInfo":_vm.conf.mainTable},on:{"mainTableReload":_vm.mainTableReload,"deleteRows":_vm.deleteRows,"saveRowByAddOrEdit":_vm.saveRowByAddOrEdit,"beforeAddViewEdit":_vm.beforeAddViewEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }